import React, { } from 'react';
import { useSelector } from 'react-redux';
import { getShkolaFromRoles } from '../../../common/Tool';
import PromokodiBlock from '../../components/PromokodiBlock';
import PageLayout from '../../components/PageLayout';
import { GET, errorCatch, useAuth } from 'fennec-ui';
import { useSchoolContext } from '../../../common/Context';



export default function SchoolComissionPromocodes(props) {
    const [school, setSchool] = useSchoolContext();

    // const shkola = useSelector(getShkolaFromRoles(["ВладелецШколыФедерации", "АдминистраторШколыФедерации"], true));
    // const auth = useAuth()
    // const [shkola, setShkola] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/school/list-by-admin', ({data})=>{
    //         setShkola(data);
    //     }, errorCatch)
    // }, [])

    return (
        <PageLayout>
            <PromokodiBlock {...props} source={"/api/promokodi/list/school?detail=model"}
                sourceKey="school"
                create={true}
                ctx={{organizatorShkolaID: school?.ID}}
                // context={{
                //     collection: shkola,
                //     name: (item) => item.nazvanieShkoliTantsev,
                //     mix: (item) => {
                //         return {
                //             // organizatorFederatsiyaID: 1, // Организатор федерация
                //             organizatorShkolaID: item.ID, // Организатор школа
                //             // organizatorMeropriyatiyaID: item.ID, // Организатор мероприятия
                //             // organizatorRegionalnoeOtdelenieID: item.ID // Организатор региональное отделение
                //         }
                //     }
                // }}
            />
        </PageLayout>
    );
}
